import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Spin } from "antd";
import {
  Logo,
  Page,
  YumyLayout,
  YumyOverlay,
  YumySider,
  YumySiderToggle,
} from "../../components/Layout/template";
import RestaurantController from "./RestaurantController";
import MenuDropdown from "./MenuDropdown";
// import MenuPoint from './MenuPoint';
import Suspense from "../../lib/refine/Suspense";
import YumyLogoWhite from "../images/yumyWhite.png";
import User from "../../components/Layout/user";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import RestaurantDropdown from "./RestaurantDropdown";
import KDSLink from "./KDSLink";
import QrLink from "./QrLink";

const Restaurant = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Function to toggle menuOpen state
  const toggleMenu = () => {
    console.log("Is it toggling?");
    setMenuOpen(!menuOpen);
  };
  return (
    <Suspense
      fallback={
        <div className="absolute left-0 top-0 right-0 bottom-0 bg-yumyBlack text-yumyGreen600 font-extrabold z-[100000] flex flex-col gap-6 justify-center items-center">
          <Spin size="large" tip="Loading Yumy" />
          Indlæser din Yumy oplevelse...
        </div>
      }
    >
      <RestaurantController>
        {() => (
          <Page>
            <YumyLayout>
              <YumySider menuOpen={menuOpen}>
                <div>
                  <Logo>
                    <img src={YumyLogoWhite} alt="Yumy Logo" />
                  </Logo>
                  <RestaurantDropdown />
                  <MenuDropdown />
                  <QrLink />
                  <KDSLink />
                </div>
                <User />
              </YumySider>
              <div className="text-yumyBlack bg-white-100 min-h-32 overflow-x-hidden px-4 pb-4 sm:px-8 sm:pb-8 xl:px-16 pt-4 xl:pb-16">
                <Outlet />
              </div>
              <YumySiderToggle onClick={toggleMenu} menuOpen={menuOpen}>
                {menuOpen ? (
                  <MenuFoldOutlined style={{ fontSize: "16px" }} />
                ) : (
                  <MenuUnfoldOutlined style={{ fontSize: "16px" }} />
                )}
              </YumySiderToggle>
              <YumyOverlay onClick={toggleMenu} menuOpen={menuOpen} />
            </YumyLayout>
          </Page>
        )}
      </RestaurantController>
    </Suspense>
  );
};

export default Restaurant;
